module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/291.da5d9b71.png";